//
// Marquee
// ---------------------------

@import "../../styles/colors";

.root {
  position: relative;
  display: flex;
  flex-flow: column wrap;
  justify-content: space-between;
  align-items: center;
  min-height: 50vh;
  margin-bottom: 50vh;
}

.divider {
  display: block;
  width: 100%;
  margin-top: 24.2vh;
  margin-bottom: 25vh;
}

.dividerParallax {
  width: 100%;
  margin-bottom: -75vh;
}

.container {
  position: relative;
  width: 40em;
}

.bullseyeRing {
  position: absolute;
  top: 20%;
  right: 7%;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.text {
  position: absolute;
  top: 38%;
  left: 0;
  width: 100%;
  text-align: center;
  margin-left: -15em;
  z-index: 2;
}

.gradient {
  z-index: 1;
}

.circleInner {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 3px solid $plum;
  border-radius: 50%;
}

.outerCircle {
  position: absolute;
  height: 168px;
  width: 168px;
  background: linear-gradient(#14ffe9, #ffeb3b, #ff00e0);
  border-radius: 50%;
  animation: rotate 15s linear infinite;
  top: 2px;
}

@keyframes rotate {
  0% {
    filter: hue-rotate(0deg);
  }
  100% {
    filter: hue-rotate(360deg);
  }
}